import { get } from "radash"

/**
 * Background image preloader service
 * Handles preloading of home background images for better UX
 */
class BackgroundPreloader {
  private preloadedImages = new Set<string>()

  /**
   * Preload background image based on cached data
   */
  preloadFromCache(): void {
    try {
      const cacheData = localStorage.getItem("be:cache")
      if (!cacheData) return

      const parsed = JSON.parse(cacheData)
      const cacheHome = get(parsed, "state.data.home-sessions", null)
      const cacheUserLoyalty = get(parsed, "state.data.user-loyalty", null)

      if (!cacheHome) return

      const backgroundList = get(cacheHome, "tier_background.tiers", [])
      const tier = get(cacheUserLoyalty, "data.tier", -1)

      let homeContent = get(
        cacheHome,
        "tier_background.default.home_content",
        "/images/b-pl.webp"
      )

      if (tier !== -1) {
        const tierBackground = backgroundList.find(
          (background: any) => background.tier === tier
        )

        if (tierBackground?.home_content) {
          homeContent = tierBackground.home_content
        }
      }

      this.preloadImage(homeContent)
    } catch {
      // Silently fail if cache parsing fails
    }
  }

  /**
   * Preload a specific image URL
   */
  preloadImage(url: string): void {
    if (!url || this.preloadedImages.has(url)) return

    const link = document.createElement("link")
    link.rel = "preload"
    link.as = "image"
    link.href = url

    document.head.appendChild(link)
    this.preloadedImages.add(url)
  }

  /**
   * Preload background image when data is available
   */
  preloadBackgroundImage(homeContent: string | undefined): void {
    if (homeContent) {
      this.preloadImage(homeContent)
    }
  }
}

export const backgroundPreloader = new BackgroundPreloader()

// Initialize preloading from cache
backgroundPreloader.preloadFromCache()
